import { Button, Form, Grid, Modal, Space, Table } from "antd";
import type { IConvenenteComConvenio } from "../../../components/Interfaces";
import { CloseOutlined, ExpandAltOutlined } from "@ant-design/icons";
import { useState, type Dispatch, type SetStateAction } from "react";
import { maskCnpj } from "../../../utils/maskFunctions";
import { formatarData } from "../../../utils/utilsFunctions";
import ConvenioAdesao from "./ConvenioAdesao";

const { useBreakpoint } = Grid;

interface IProps {
  convenentesComConvenios: IConvenenteComConvenio[];
  manter: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setTipLoading: Dispatch<SetStateAction<string>>;
}

const ListarConvenentesConvenioAdesao = ({ convenentesComConvenios, manter, setLoading, setTipLoading }: IProps) => {
  const screens = useBreakpoint();
  const [serieConvenio, setSerieConvenio] = useState(0);
  const [exibirModal, setExibirModal] = useState(false);

  const colunasConvenenteComConvenio = [
    {
      key: "1",
      title: "CNPJ",
      render: (convenenteComConvenio: IConvenenteComConvenio) => (
        <div>
          {convenenteComConvenio.pessoaJuridica?.numero ? maskCnpj(convenenteComConvenio.pessoaJuridica?.numero) : ""}
        </div>
      ),
    },
    {
      key: "2",
      title: "Razão Social",
      render: (convenenteComConvenio: IConvenenteComConvenio) => (
        <div>
          {convenenteComConvenio.pessoaJuridica?.razaoSocial}
        </div>
      ),
    },
    {
      key: "3",
      title: "Tipo",
      render: (convenenteComConvenio: IConvenenteComConvenio) => (
        <div>
          {convenenteComConvenio.convenio.tipoConvenio}
        </div>
      ),
    },
    {
      key: "4",
      title: "Data de início da vigência",
      render: (convenenteComConvenio: IConvenenteComConvenio) => (
        <div>
          {formatarData(convenenteComConvenio.convenio.dataInicioVigencia)}
        </div>
      ),
    },
    {
      key: "5",
      title: "Opções",
      render: (convenenteComConvenio: IConvenenteComConvenio) => (
        <>
          <Space>
            <div style={{ display: [1, 2, 3].includes(manter) ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  if (convenenteComConvenio.convenio.serie) {
                    setSerieConvenio(convenenteComConvenio.convenio.serie);
                    setExibirModal(true);
                  }
                }}
              />
            </div>
          </Space>
        </>
      ),
    }
  ];

  const handleCancel = () => {
    setExibirModal(false);
  };

  return (
    <>
      <Modal title="Convênio de adesão" open={exibirModal}
        style={{ top: 20 }}
        width={screens.xl ? 1000 : 600}
        destroyOnHidden={true}
        closable={false}
        footer={[
          <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
            Fechar
          </Button>,
        ]}
      >
        <ConvenioAdesao
          serieConvenio={serieConvenio}
          setLoading={setLoading}
          setTipLoading={setTipLoading}
          manter={manter}
        />
      </Modal>

      <Table size="small" columns={colunasConvenenteComConvenio} dataSource={convenentesComConvenios} />
    </>
  );
}

export default ListarConvenentesConvenioAdesao;
